<fdx-common-core> 

    <app-header *ngIf="isSmallScreen" [isSmallScreen]="isSmallScreen" [showOpenCloseBtn]="false"></app-header>
    <!--<mat-sidenav-container [hasBackdrop]='false'>-->
      <app-header *ngIf="!isSmallScreen" [isSmallScreen]="isSmallScreen" [showOpenCloseBtn]="false"></app-header>
      <div class="fxg-wrapper" style=" min-height: calc(100vh - 80px);">    
        <div class="fxg-margin-top-80">          
          <div class="fdx-c-loading-indicator fdx-c-loading-indicator-wcenter" *ngIf="isLoading | async" mode="indeterminate" color="warn" style="z-index: 5000;">
            <div class="fdx-c-loading-indicator__part"></div>
            <div class="fdx-c-loading-indicator__part"></div>
            <div class="fdx-c-loading-indicator__part"></div>
            <div class="fdx-c-loading-indicator__part"></div>
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
      <!--<app-footer></app-footer>-->
    <!--</mat-sidenav-container>-->
    </fdx-common-core>